import axios from "@/api/axios";
//import store from '@/store'
import _ from "lodash";

// 메인 가지고 오기
const get_main = async (result) => {
  let finalData = {
    code: "",
    message: "",
    tournamenttopcnt: 0,
    tournamenttop: [],
    swingtopcnt: 0,
    swingtop: [],
    coursetopcnt: 0,
    coursetop: [],
  };
  const token = sessionStorage.getItem("token") || null;
  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/main",
    headers: { Authorization: "Bearer " + token },
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
  };
  try {
    await axios(options).then((response) => {
      console.log(response);
      if (response.status === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.status, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_main", err);
    result(false, err);
  }
};

// 인스타그램 가지고 오기
const get_instagram = async (token, result) => {
  let finalData = {
    data: [],
  };

  const options = {
    method: "GET",
    url: "https://graph.instagram.com/me/media",
    params: {
      fields:
        "caption,id,media_type,media_url,permalink,thumbnail_url,timestamp,username",
      access_token: token,
      limit: 10,
    },
  };
  try {
    await axios(options).then((response) => {
      result(true, response.data);
    });
  } catch (err) {
    console.error("get_instagram", err);
    result(false, err);
  }
};

export default {
  get_main,
  get_instagram,
};
